import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { TdElement } from "./td-viewModel"

export class TdView extends FormBuilderComponentView<TdElement>{
    GetViewUniqueId(): string {
        return "V-26FB070D-7983-40CB-981A-0DDAF8BB0400"
    }
    loadHtml(): string {
        let element = require('./td.html').default;
        let style = require('./td.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;

}
